// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"Kulumynd-module--imageWrapper--AgN4U","image":"Kulumynd-module--image--2D6mR"};